import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import merge from 'lodash/merge';
import { useMemo } from 'react';
import RevealedSection from '@/components/Editor/Form/fields/RevealedSection';
import { Label, PaddingControl } from '@/components/FormElements';
import { getCssPadding, getDefaultPadding } from '@/components/FormElements/PaddingControl/util';
import { getSectionPaddingProperties } from '@/components/widget/misc/StyleVariables';
import controlStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const SectionLayoutFields = _ref => {
  let {
    className = ''
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(RevealedSection, {
    label: "Layout Styles",
    className: className,
    children: /*#__PURE__*/_jsx(PaddingFields, _objectSpread({}, props))
  });
};

export const PaddingFields = _ref2 => {
  var _section$config5;

  let {
    section,
    widgetId,
    sectionId,
    onChange
  } = _ref2;
  // Get the default padding for the section
  const defaultPadding = useMemo(() => {
    var _section$config, _section$config$style, _section$config2, _section$config2$styl, _section$config3, _section$config3$styl, _section$config4, _section$config4$styl;

    const sectionPadding = {
      paddingTop: (_section$config = section.config) === null || _section$config === void 0 ? void 0 : (_section$config$style = _section$config.styles) === null || _section$config$style === void 0 ? void 0 : _section$config$style.paddingTop,
      paddingBottom: (_section$config2 = section.config) === null || _section$config2 === void 0 ? void 0 : (_section$config2$styl = _section$config2.styles) === null || _section$config2$styl === void 0 ? void 0 : _section$config2$styl.paddingBottom,
      paddingRight: (_section$config3 = section.config) === null || _section$config3 === void 0 ? void 0 : (_section$config3$styl = _section$config3.styles) === null || _section$config3$styl === void 0 ? void 0 : _section$config3$styl.paddingRight,
      paddingLeft: (_section$config4 = section.config) === null || _section$config4 === void 0 ? void 0 : (_section$config4$styl = _section$config4.styles) === null || _section$config4$styl === void 0 ? void 0 : _section$config4$styl.paddingLeft
    }; // Get the padding properties from the section's computed styles

    const computedStyles = getSectionPaddingProperties(widgetId, sectionId);
    if (!computedStyles) return sectionPadding; // Merge the section padding with the computed padding
    // to get the default padding

    return merge(sectionPadding, getDefaultPadding(computedStyles, true));
  }, [widgetId, sectionId, (_section$config5 = section.config) === null || _section$config5 === void 0 ? void 0 : _section$config5.styles]);
  return /*#__PURE__*/_jsx(Label, {
    headingOnly: true,
    text: "Padding",
    caption: "White space that surrounds this section",
    className: controlStyles.formField,
    children: /*#__PURE__*/_jsx(PaddingControl, {
      defaultValue: defaultPadding,
      onChange: padding => onChange(getCssPadding(padding))
    }, `padding-control-${section.id}-${section.elementId}`)
  });
};
export default SectionLayoutFields;